import React from 'react';
import { PostAuthor, PublishedAt } from './post-card';
import HeroSubmenu, { hasSubmenu } from '../../fragments/hero-submenu';
import { useImageLoaded } from '~/hooks/useImage';
import { getParentPageSubmenu } from '~/utils/helpers';

interface BlogHeroDetailedProps {
  block: any;
  parentPage: any;
  data: BlogPost;
}

const BlogHeroDetailed: React.FC<BlogHeroDetailedProps> = ({
  block,
  parentPage,
  data,
}) => {
  const [ref, loaded, onLoad] = useImageLoaded();
  const submenuField = block.submenu_field
    ? block.submenu_field
    : getParentPageSubmenu(parentPage);
  const parentTitle = submenuField.menu_group_title;
  const submenuClass = hasSubmenu(submenuField) ? 'has-submenu' : '';

  return (
    <section
      className={`block ${block._template} ${block.css_class_name} ${submenuClass} block-hero--details`}
    >
      <div className='container--hero-image container'>
        <HeroSubmenu
          block={submenuField}
          parentTitle={parentTitle}
        />
        <div className='row'>
          <div className='blog-hero-field'>
            <div className={`blog-image ${loaded ? 'loaded' : ''}`}>
              <img
                ref={ref}
                className={`blog-hero-field__image ${loaded ? 'loaded' : ''}`}
                src={data.feature_image}
                alt={''}
                onLoad={onLoad}
                loading='lazy'
              />
            </div>
          </div>
        </div>
      </div>
      <div className='container--hero-content container'>
        <div className='row'>
          <h1 className='blog-hero__title'>{data.title}</h1>
          <div className='blog-hero__author'>
            <span className='blog-hero__posted-by'>Posted by: </span>
            {data.authors &&
              data.authors.map(author => (
                <PostAuthor
                  key={author.name}
                  author={author}
                />
              ))}
            {!data.authors && <PostAuthor author={data.primary_author} />}
            <PublishedAt
              dateTime={data.published_at}
              showIcon={true}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

// Uses same fragment for graphql query as BlogHero

export default BlogHeroDetailed;
